/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './ActionTypes';
import { handleExistingCommentList } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  checkInputValueNumber,
  removeWhiteSpaceForNDC,
} from '../components/gridComponents/pqasUtils';

const initialState = {
  getInvoiceHeader: {},
  saveDetailResponse: {},
  disabledIntPaidColObj: {},
  pqasgridData: [],
  pqasOriginal: {},
  duplicatePQASGrid: {},
  drugsFullyPartially: [],
  allAdjDisputeCodes: [],
  uraData: [],
  pqasSummaryGridList: {},
  pqasGridLevelActions: {},
  detailScreenObj: {},
  npSuspended: {},
  recalValuesForPqas: {},
  updatedPqasGrid: [],
  idsDealloc: {},
  istrDeAlloc: {},
  deallocateNdcPqas: {},
  getDeleteRow: {},
  paidAllocateAmt: undefined,
  duplicatePqasInterestIndex: null,
  loadPQASGridErrorObj: {
    alert: false,
    msg: '',
  },
  addOrDuplicateNDCPQASObj: {},
  isColumnDone: false,
  ibOpening: true,
};

let newObj = [];
let summaryGird = [];
const colorCode = {
  greenCd: '00b300',
  greyCd: '12632256',
  disGreyCd: '12632256',
  // disGreyCd: '78682240',
  yellowCd: '11534335',
  whiteCd: '16777215',
  redCd: 'b31f00',
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ALLOCATE_PAYMENTS_2_INVOICEHEADER:
      return { ...state, getInvoiceHeader: action.payload };
    case actionTypes.DEALLOCATE_NDC_PQAS:
      return { ...state, deallocateNdcPqas: action.payload };
    case actionTypes.ID_DEALLOC_PQAS:
      return { ...state, idsDealloc: action.payload };
    case actionTypes.GET_DELETED_ROW:
      return { ...state, getDeleteRow: action.payload };
    case actionTypes.SET_PRE_INIT_DATA:
      return { ...state, preInitializeResponse: action.payload };
    case actionTypes.SET_DUPLICATE_PQAS_INTEREST_INDEX:
      return { ...state, duplicatePqasInterestIndex: action.payload };
    case actionTypes.GET_PQASGRID_AP2:
      newObj = action.payload;
      const orgData = _.cloneDeep(state.pqasOriginal);
      const { invoiceNum, checkLogNum, recancilationNumber } =
        action?.headerData;
      orgData[`${invoiceNum}-${checkLogNum}`] = !_.isEmpty(orgData)
        ? orgData[`${invoiceNum}-${checkLogNum}`]
          ? orgData[`${invoiceNum}-${checkLogNum}`]
          : []
        : [];
      if (invoiceNum && action?.isUpdateData) {
        if (
          // recancilationNumber = recancilationNumber || 0;

          newObj &&
          !_.isEmpty(newObj) &&
          !newObj?.filter((x) => {
            return x.addEditRow;
          }).length > 0
        ) {
          handleExistingCommentList(newObj, '', 'allList').then((res) => {
            newObj = res?.map((item, rowIndex) => {
              // item.invRecSeqNum = item?.invRecSeqNum || 0;
              item.id = item.id ? item.id : uuidv4();
              item.addEditRow = item.addEditRow ? item.addEditRow : false;
              item.updateInRow = item.updateInRow ? item.updateInRow : false;
              item.ccPaidInFullInd = item.pqasDrugStatusCd === 'PIF' ? 1 : 0;
              item.discrepancyAlert = item.discrepancyAlert
                ? item.discrepancyAlert
                : false;
              item.currUnits = checkInputValueNumber(item.currUnits, 3);
              item.interestPaid = item.interestPaid || parseFloat(0).toFixed(2);
              item.ndc =
                item.ndc && item.ndc !== ''
                  ? item.ndc
                  : `${item.labelerCode}-${item.productCode}-${item.packageSize}`;
              item.ndc = `${removeWhiteSpaceForNDC(item.ndc)}//${uuidv4()}`;
              let amt = 0;
              if (item.productCode == 'ADJS' || item.packageSize == 'NV') {
                item.currUnitRebateAmt = 1;
              }
              if (
                newObj &&
                item.drugdrugSeqNum === newObj[rowIndex - 1]?.drugSeqNum
              ) {
                amt = 0;
              } else {
                amt =
                  (item.currUnitRebateAmt
                    ? item.currUnitRebateAmt
                    : item.pqidunitRebateAmt) *
                  (item.currUnits ? item.currUnits : item.pqidnumOfUnits);
              }
              item.cfSumOwedAmt = amt;
              if (!item.drugSeqNum?.toString() === '0') {
                item.currUnits =
                  newObj && item.drugSeqNum === newObj[rowIndex - 1]?.drugSeqNum
                    ? checkInputValueNumber(item.currUnits, 3)
                    : '0.0000';
              }
              // item.interestCalc =
              //   (parseFloat(item?.ccInterestowed) *
              //     (item.currUnitsPaid !== null ||
              //     parseFloat(item.currUnitsPaid) === 0
              //       ? parseFloat(item.currUnits || 0)
              //       : parseFloat(item.currUnitsPaid || 0))) /
              //   parseFloat(item.currUnits || 0);
              item.interestCalc = Number.isNaN(item.interestCalc || 0)
                ? parseFloat(0).toFixed(2)
                : parseFloat(item.interestCalc || 0).toFixed(2);
              item.ccInterestAllocated = Number.isNaN(item.ccInterestAllocated)
                ? parseFloat(0).toFixed(2)
                : parseFloat(item.ccInterestAllocated).toFixed(2);
              item.cidunitRebateAmt = item.cidunitRebateAmt
                ? parseFloat(item.cidunitRebateAmt).toFixed(6)
                : parseFloat(0).toFixed(6);
              item.currUnitRebateAmt = item.currUnitRebateAmt
                ? parseFloat(item.currUnitRebateAmt).toFixed(6)
                : parseFloat(0).toFixed(6);
              item.xorigCurrUnitsPaid = item.xorigCurrUnitsPaid
                ? parseFloat(item.xorigCurrUnitsPaid).toFixed(4)
                : parseFloat(0).toFixed(4);
              item.totReimbursedUnits = item.totReimbursedUnits
                ? parseFloat(item.totReimbursedUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.totReimbursedAmt = item.totReimbursedAmt
                ? parseFloat(item.totReimbursedAmt).toFixed(4)
                : parseFloat(0).toFixed(4);
              item.priorPaidUnits = item.priorPaidUnits
                ? parseFloat(item.priorPaidUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.xorigAmtPtt = (
                parseFloat(item.cidunitRebateAmt || 0) *
                parseFloat(item.totReimbursedUnits || 0)
              ).toFixed(2);
              item.xorigAmtPtt = item.xorigAmtPtt
                ? parseFloat(item.xorigAmtPtt).toFixed(2)
                : parseFloat(0).toFixed(2);
              item.revisedInvoiceAmt = item.revisedInvoiceAmt
                ? parseFloat(item.revisedInvoiceAmt).toFixed(2)
                : parseFloat(0).toFixed(2);
              item.priorPaidAmt = item.priorPaidAmt
                ? parseFloat(item.priorPaidAmt).toFixed(2)
                : parseFloat(0).toFixed(2);
              item.currAmtPaid = item.currAmtPaid
                ? parseFloat(item.currAmtPaid).toFixed(2)
                : parseFloat(0).toFixed(2);
              item.paidThisTransactionAmt = item.paidThisTransactionAmt
                ? parseFloat(item.paidThisTransactionAmt).toFixed(2)
                : parseFloat(0).toFixed(2);
              item.currUnitsPaid = item.currUnitsPaid
                ? parseFloat(item.currUnitsPaid).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.priorDisputedUnits = item.priorDisputedUnits
                ? parseFloat(item.priorDisputedUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.currUnitsDisputed =
                item.currUnitsDisputed === null ||
                item.currUnitsDisputed === '' ||
                item.currUnitsDisputed?.toString() === '0' ||
                isNaN(item.currUnitsDisputed)
                  ? ''
                  : parseFloat(item.currUnitsDisputed).toFixed(3);

              item.isModifiedCurrUnitsDisputedColumn = false;

              // for color and enable/diable
              item.disabledForCcInterestAllocated = false;
              item.isAllowFormatterCcInterestAllocated = false;
              item.isAllowFormatterInterestCalc = false;
              item.isAllowFormatterPriorPaidAmt = false;
              item.isAllowFormatterCurrAmtPaid = false;
              item.isAllowFormatterPaidThisTransactionAmt = false;
              item.bgColorForCcInterestAllocated = colorCode.whiteCd;
              item.disabledForInterestCalc = true;
              item.disabledForOrgURA = true;
              item.disabledForOrgUnitsInv = true;
              item.disabledForRevisedInvAmt = true;
              item.autoFocusCcAc1 = false;
              item.autoFocusCcAc2 = false;
              item.autoFocusCcAc3 = false;
              item.autoFocusCcDc1 = false;
              item.autoFocusCcDc2 = false;
              item.autoFocusCcDc3 = false;
              if (
                item.invRecSeqNum == recancilationNumber ||
                parseInt(item.invRecSeqNum, [0, 1]) === 0
              ) {
                if (
                  parseFloat(item?.ccOverrideColorDis) >= 0 ||
                  item.statusCd === 'WO' ||
                  item.statusCd === 'FG' ||
                  item.statusCd === 'DB' ||
                  item.statusCd === 'DBK'
                ) {
                  item.bgColorForNDC = '00b300'; // Green color
                  item.bgColor = '00b300';
                } else {
                  item.bgColorForNDC = '12632256'; // Grey color
                  item.bgColor = '12632256';
                }
              } else {
                item.bgColorForNDC = '11534335'; // yellow color
                if (
                  parseFloat(item?.ccOverrideColorDis) >= 0 ||
                  item.statusCd === 'WO' ||
                  item.statusCd === 'FG' ||
                  item.statusCd === 'DB' ||
                  item.statusCd === 'DBK'
                ) {
                  item.bgColor = '00b300'; // Green color
                } else {
                  item.bgColor = '11534335'; // yellow color
                }
              }
              if (
                parseFloat(item?.ccOverrideColorDis) >= 0 ||
                item.statusCd === 'WO' ||
                item.statusCd === 'FG' ||
                item.statusCd === 'DB' ||
                item.statusCd === 'DBK'
              ) {
                item.bgColorForInterestCalc = colorCode.greenCd;
                item.bgColorForOrgURA = colorCode.greenCd;
                item.bgColorForOrgUnitsInv = colorCode.greenCd;
                item.bgColorForOrgInvAmt = colorCode.greenCd;
                item.bgColorForRevisedInvAmt = colorCode.greenCd;
              } else {
                item.bgColorForInterestCalc = colorCode.disGreyCd;
                item.bgColorForOrgURA = colorCode.disGreyCd;
                item.bgColorForOrgUnitsInv = colorCode.disGreyCd;
                item.bgColorForOrgInvAmt = colorCode.disGreyCd;
                item.bgColorForRevisedInvAmt = colorCode.disGreyCd;
              }
              if (
                item?.invRecSeqNum === recancilationNumber ||
                item?.invRecSeqNum === 0 ||
                !item?.invRecSeqNum ||
                item?.invRecSeqNum === null
              ) {
                item.disabledForPaidInFullInd = false;
                item.bgColorForPaidInFullInd = colorCode.whiteCd;
                if (parseFloat(item?.ccPaidInFullInd) === 1) {
                  item.disabledForCurrURA = true;
                  item.disabledForCurrUnits = true;
                  item.disabledForCurrUnitsPaid = true;
                  item.bgColorForCurrUnitsDisputed = true;
                  item.disabledForCurrAmtPaid = true;
                  item.disabledForAmtPaidThisTran = true;
                  item.disabledForCcAc1 = true;
                  item.disabledForCcAc2 = true;
                  item.disabledForCcAc3 = true;
                  item.disabledForCcDc1 = true;
                  item.disabledForCcDc2 = true;
                  item.disabledForCcDc3 = true;
                  if (
                    parseFloat(item?.ccOverrideColorDis) >= 0 ||
                    item.statusCd === 'WO' ||
                    item.statusCd === 'FG' ||
                    item.statusCd === 'DB' ||
                    item.statusCd === 'DBK'
                  ) {
                    item.bgColorForCurrURA = colorCode.greenCd;
                    item.bgColorForCurrUnits = colorCode.greenCd;
                    item.bgColorForCurrAmtPaid = colorCode.greenCd;
                    item.bgColorForAmtPaidThisTran = colorCode.greenCd;
                    item.bgColorForCcAc1 = colorCode.greenCd;
                    item.bgColorForCcAc2 = colorCode.greenCd;
                    item.bgColorForCcAc3 = colorCode.greenCd;
                    item.bgColorForCcDc1 = colorCode.greenCd;
                    item.bgColorForCcDc2 = colorCode.greenCd;
                    item.bgColorForCcDc3 = colorCode.greenCd;
                  } else {
                    item.bgColorForCurrURA = colorCode.disGreyCd;
                    item.bgColorForCurrUnits = colorCode.disGreyCd;
                    item.bgColorForCurrAmtPaid = colorCode.disGreyCd;
                    item.bgColorForAmtPaidThisTran = colorCode.disGreyCd;
                    item.bgColorForCcAc1 = colorCode.disGreyCd;
                    item.bgColorForCcAc2 = colorCode.disGreyCd;
                    item.bgColorForCcAc3 = colorCode.disGreyCd;
                    item.bgColorForCcDc1 = colorCode.disGreyCd;
                    item.bgColorForCcDc2 = colorCode.disGreyCd;
                    item.bgColorForCcDc3 = colorCode.disGreyCd;
                  }
                } else {
                  item.disabledForCurrURA = false;
                  item.disabledForCurrUnits = false;
                  item.disabledForCurrUnitsPaid = false;
                  item.bgColorForCurrUnitsDisputed = false;
                  item.disabledForCurrAmtPaid = false;
                  item.disabledForAmtPaidThisTran = false;
                  item.disabledForCcAc1 = false;
                  item.disabledForCcAc2 = false;
                  item.disabledForCcAc3 = false;
                  item.disabledForCcDc1 = false;
                  item.disabledForCcDc2 = false;
                  item.disabledForCcDc3 = false;
                  item.bgColorForCurrURA = colorCode?.whiteCd;
                  item.bgColorForCurrUnits = colorCode?.whiteCd;
                  item.bgColorForCurrAmtPaid = colorCode?.whiteCd;
                  item.bgColorForAmtPaidThisTran = colorCode?.whiteCd;
                  item.bgColorForCcAc1 = colorCode?.whiteCd;
                  item.bgColorForCcAc2 = colorCode?.whiteCd;
                  item.bgColorForCcAc3 = colorCode?.whiteCd;
                  item.bgColorForCcDc1 = colorCode?.whiteCd;
                  item.bgColorForCcDc2 = colorCode?.whiteCd;
                  item.bgColorForCcDc3 = colorCode?.whiteCd;
                }
                if (
                  parseFloat(item?.ccPaidInFullInd) === 1 ||
                  parseFloat(item?.ccOverridePrevVals) === 0
                ) {
                  item.disabledForPriorUnitsPaid = true;
                  item.disabledForPriorUnitsDisputed = true;
                  item.disabledForPriorAmtPaid = true;
                  item.bgColorForPriorUnitsPaid =
                    item?.ccOverridColorDis === colorCode.greenCd ||
                    parseFloat(item?.ccOverridColorDis) >= 0
                      ? colorCode.greenCd
                      : colorCode.disGreyCd;
                  item.bgColorForPriorUnitsDisputed =
                    item?.ccOverridColorDis === colorCode.greenCd ||
                    parseFloat(item?.ccOverridColorDis) >= 0
                      ? colorCode.greenCd
                      : colorCode.disGreyCd;
                  item.bgColorForPriorAmtPaid =
                    item?.ccOverridColorDis === colorCode.greenCd ||
                    parseFloat(item?.ccOverridColorDis) >= 0
                      ? colorCode.greenCd
                      : colorCode.disGreyCd;
                } else {
                  item.disabledForPriorUnitsPaid = false;
                  item.disabledForPriorUnitsDisputed = false;
                  item.disabledForPriorAmtPaid = false;
                  item.bgColorForPriorUnitsPaid = colorCode?.whiteCd;
                  item.bgColorForPriorUnitsDisputed = colorCode?.whiteCd;
                  item.bgColorForPriorAmtPaid = colorCode?.whiteCd;
                }
                if (parseFloat(item?.currUnitsPaid) < 0) {
                  item.bgColorForCurrUnitsPaid = colorCode.redCd;
                  item.bgColorForCurrUnitsDisputed = colorCode.redCd;
                } else if (parseFloat(item?.ccPaidInFullInd) === 1) {
                  item.bgColorForCurrUnitsPaid =
                    item?.ccOverridColorDis === colorCode.greenCd ||
                    parseFloat(item?.ccOverridColorDis) >= 0
                      ? colorCode.greenCd
                      : colorCode.disGreyCd;
                  item.bgColorForCurrUnitsDisputed =
                    item?.ccOverridColorDis === colorCode.greenCd ||
                    parseFloat(item?.ccOverridColorDis) >= 0
                      ? colorCode.greenCd
                      : colorCode.disGreyCd;
                } else {
                  item.bgColorForCurrUnitsPaid = colorCode.whiteCd;
                  item.bgColorForCurrUnitsDisputed = colorCode.whiteCd;
                }
              } else {
                item.disabledForPaidInFullInd = true;
                item.disabledForCurrURA = true;
                item.disabledForCurrUnits = true;
                item.disabledForPriorUnitsPaid = true;
                item.disabledForCurrUnitsPaid = true;
                item.disabledForPriorUnitsDisputed = true;
                item.disabledForCurrUnitsDisputed = true;
                item.disabledForPriorAmtPaid = true;
                item.disabledForCurrAmtPaid = true;
                item.disabledForAmtPaidThisTran = true;
                item.disabledForCcAc1 = true;
                item.disabledForCcAc2 = true;
                item.disabledForCcAc3 = true;
                item.disabledForCcDc1 = true;
                item.disabledForCcDc2 = true;
                item.disabledForCcDc3 = true;
                if (
                  item?.ccOverridColorDis === colorCode.greenCd ||
                  parseFloat(item?.ccOverridColorDis) >= 0 ||
                  item.statusCd === 'WO' ||
                  item.statusCd === 'FG' ||
                  item.statusCd === 'DB' ||
                  item.statusCd === 'DBK'
                ) {
                  item.bgColorForCurrURA = colorCode.greenCd;
                  item.bgColorForCurrUnits = colorCode.greenCd;
                  item.bgColorForCurrAmtPaid = colorCode.greenCd;
                  item.bgColorForAmtPaidThisTran = colorCode.greenCd;
                  item.bgColorForPriorUnitsPaid = colorCode.greenCd;
                  item.bgColorForCcAc1 = colorCode.greenCd;
                  item.bgColorForCcAc2 = colorCode.greenCd;
                  item.bgColorForCcAc3 = colorCode.greenCd;
                  item.bgColorForCcDc1 = colorCode.greenCd;
                  item.bgColorForCcDc2 = colorCode.greenCd;
                  item.bgColorForCcDc3 = colorCode.greenCd;
                  item.bgColorForPaidInFullInd = colorCode.greenCd;
                  item.bgColorForCurrUnitsPaid = colorCode.greenCd;
                  item.bgColorForPriorUnitsDisputed = colorCode.greenCd;
                  item.bgColorForPriorAmtPaid = colorCode.greenCd;
                  item.bgColorForCurrAmtPaid = colorCode.greenCd;
                  item.bgColorForAmtPaidThisTran = colorCode.greenCd;
                } else {
                  item.bgColorForCurrURA = colorCode.disGreyCd;
                  item.bgColorForCurrUnits = colorCode.disGreyCd;
                  item.bgColorForCurrAmtPaid = colorCode.disGreyCd;
                  item.bgColorForAmtPaidThisTran = colorCode.disGreyCd;
                  item.bgColorForPriorUnitsPaid = colorCode.disGreyCd;
                  item.bgColorForCcAc1 = colorCode.disGreyCd;
                  item.bgColorForCcAc2 = colorCode.disGreyCd;
                  item.bgColorForCcAc3 = colorCode.disGreyCd;
                  item.bgColorForCcDc1 = colorCode.disGreyCd;
                  item.bgColorForCcDc2 = colorCode.disGreyCd;
                  item.bgColorForCcDc3 = colorCode.disGreyCd;
                  item.bgColorForPaidInFullInd = colorCode.disGreyCd;
                  item.bgColorForCurrUnitsPaid = colorCode.disGreyCd;
                  item.bgColorForPriorUnitsDisputed = colorCode.disGreyCd;
                  item.bgColorForPriorAmtPaid = colorCode.disGreyCd;
                  item.bgColorForCurrAmtPaid = colorCode.disGreyCd;
                  item.bgColorForAmtPaidThisTran = colorCode.disGreyCd;
                }
              }
              item.ccAc1 = item.ccAc1 && item.ccAc1 !== '0' ? item.ccAc1 : '-1';
              item.ccAc2 = item.ccAc2 && item.ccAc2 !== '0' ? item.ccAc2 : '-1';
              item.ccAc3 = item.ccAc3 && item.ccAc3 !== '0' ? item.ccAc3 : '-1';
              item.ccDc1 = item.ccDc1 && item.ccDc1 !== '0' ? item.ccDc1 : '-1';
              item.ccDc2 = item.ccDc2 && item.ccDc2 !== '0' ? item.ccDc2 : '-1';
              item.ccDc3 = item.ccDc3 && item.ccDc3 !== '0' ? item.ccDc3 : '-1';
              return item;
            });
            // orgData[invoiceNum] = [];
            orgData[`${invoiceNum}-${checkLogNum}`] = _.cloneDeep(
              newObj?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1))
            );
          });
        }
      }
      let originalPQASGridRow = {};
      if (action?.onloadData?.length > 0) {
        originalPQASGridRow[`${invoiceNum}-${checkLogNum}`] =
          newObj?.length > 0 ? JSON.parse(JSON.stringify(newObj)) : [];
      } else {
        originalPQASGridRow = { ...state.duplicatePQASGrid };
      }
      return {
        ...state,
        pqasgridData: {
          ...state.pqasgridData,
          [`${invoiceNum}-${checkLogNum}`]: newObj?.sort((a, b) =>
            a.ndc > b.ndc ? 1 : -1
          ),
        },
        pqasOriginal: orgData,
        duplicatePQASGrid: originalPQASGridRow,
      };
    case actionTypes.PQAS_DRUGS_PAID_FULLY_OR_PARTIALLY:
      return { ...state, drugsFullyPartially: action.payload };
    case actionTypes.ADJ_DISPUTE_CODES:
      return { ...state, allAdjDisputeCodes: action.payload };
    case actionTypes.URA_FROM_DQD:
      return { ...state, uraData: action.payload };
    case actionTypes.PQAS_TG_ACTIONS:
      return {
        ...state,
        pqasGridLevelActions: {
          ...state.pqasGridLevelActions,
          ...action.payload,
        },
      };
    case actionTypes.GET_PQAS_SUMMARY_GRID:
      summaryGird = _.cloneDeep(action.summaryGridList);
      if (action?.invoiceNum && action?.isUpdateData) {
        if (
          action.summaryGridList[`${action?.invoiceNum}-${action?.checkLogNum}`]
        ) {
          summaryGird[`${action?.invoiceNum}-${action?.checkLogNum}`] =
            summaryGird[`${action?.invoiceNum}-${action?.checkLogNum}`]?.map(
              (item, index) => {
                item.key = index;
                item.disabledForIntPaidThisCheck = false;
                item.isAllowFormatterIntPaidThisCheck =
                  item.isAllowFormatterIntPaidThisCheck || false;
                item.bgColorForIntPaidThisCheck = '';
                item.currentPrincipalAmt = item.currentPrincipalAmt
                  ? item.currentPrincipalAmt
                  : parseFloat(0).toFixed(2);
                item.totalInterestCalc = item.totalInterestCalc
                  ? item.totalInterestCalc
                  : parseFloat(0).toFixed(2);
                item.totalPrincipalPaid = item.totalPrincipalPaid
                  ? item.totalPrincipalPaid
                  : parseFloat(0).toFixed(2);
                item.principalPaidThisCheck = item.principalPaidThisCheck
                  ? item.principalPaidThisCheck
                  : parseFloat(0).toFixed(2);
                item.totalIntPaid = item.totalIntPaid
                  ? item.totalIntPaid
                  : parseFloat(0).toFixed(2);
                item.totalIntSettled = item.totalIntSettled
                  ? item.totalIntSettled
                  : parseFloat(0).toFixed(2);
                item.intPaidThisCheck = item.intPaidThisCheck
                  ? item.intPaidThisCheck
                  : parseFloat(0).toFixed(2);
                item.statusCd = item.statusCd ? item.statusCd : 'NotModified';
                // item.bgColorForIntPaidThisCheck = colorCode.whiteCd;
                // if (item.intPaidThisCheck && item.intPaidThisCheck !== 0) {
                //   item.bgColorForIntPaidThisCheck = colorCode.greyCd;
                //   item.disabledForIntPaidThisCheck = true;
                // }
                if (!item.currentPrincipalAmt?.toString()?.includes('$'))
                  item.currentPrincipalAmt = `$ ${
                    item.currentPrincipalAmt
                      ? parseFloat(item.currentPrincipalAmt).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalInterestCalc?.toString()?.includes('$'))
                  item.totalInterestCalc = `$ ${
                    item.totalInterestCalc
                      ? parseFloat(item.totalInterestCalc).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalPrincipalPaid?.toString()?.includes('$'))
                  item.totalPrincipalPaid = `$ ${
                    item.totalPrincipalPaid
                      ? parseFloat(item.totalPrincipalPaid).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.principalPaidThisCheck?.toString()?.includes('$'))
                  item.principalPaidThisCheck = `$ ${
                    item.principalPaidThisCheck
                      ? parseFloat(item.principalPaidThisCheck).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalIntPaid?.toString()?.includes('$'))
                  item.totalIntPaid = `$ ${
                    item.totalIntPaid
                      ? parseFloat(item.totalIntPaid).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalIntSettled?.toString()?.includes('$'))
                  item.totalIntSettled = `$ ${
                    item.totalIntSettled
                      ? parseFloat(item.totalIntSettled).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.intPaidThisCheck?.toString()?.includes('$'))
                  item.intPaidThisCheck = `${
                    item.intPaidThisCheck
                      ? parseFloat(item.intPaidThisCheck).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                return item;
              }
            );
        }
      }

      return {
        ...state,
        pqasSummaryGridList: { ...state.pqasSummaryGridList, ...summaryGird },
      };
    case actionTypes.PQRS_ALLOCATE_PAYMENT_DETAIL_SCREEN:
      return { ...state, detailScreenObj: action.detailScreenObj };
    case actionTypes.NP_SUSPENDED:
      return { ...state, npSuspended: action.payload };
    case actionTypes.DISABLED_INT_PAID_COLUMN_PQAS:
      return { ...state, disabledIntPaidColObj: action.disabledIntPaidColObj };
    case actionTypes.GET_RECALC_VALUES_FOR_PQAS:
      return { ...state, recalValuesForPqas: action.payload };
    case actionTypes.GET_POST_INIT_BY_MIR:
      return { ...state, getPostInitRes: action.payload };
    case actionTypes.PRIOR_CURRENT_UNITS_RESPONSE:
      return { ...state, getPriorCurrUnitRes: action.payload };
    case actionTypes.SUM_ORG_PAID_AMT:
      return { ...state, sumOrgPaidAmt: action.payload };
    case actionTypes.UPDATE_PQAS_GRID:
      return { ...state, updatedPqasGrid: action.payload };
    case actionTypes.SAVE_DETAILS:
      return { ...state, saveDetailResponse: action.payload };
    case actionTypes.ISTR_DEALLOC_DATA:
      return { ...state, istrDeAlloc: action.payload };
    case actionTypes.LOAD_PQAS_GRID_ERROR:
      return {
        ...state,
        loadPQASGridErrorObj: action.loadPQASGridErrorObj,
      };
    case actionTypes.CURR_COL_ID:
      return { ...state, currColId: action.payload };
    case actionTypes.SET_PAID_ALLOCATED_AMT:
      return { ...state, paidAllocateAmt: action.payload };
    case actionTypes.ADD_OR_DUPLICATE_NDC_PQAS:
      return {
        ...state,
        addOrDuplicateNDCPQASObj: action.addOrDuplicateNDCPQASObj,
      };
    case actionTypes.ALLOCATE_PAYMENTS_2_IS_COLUMN_DONE:
      return { ...state, isColumnDone: action.payload };
    case actionTypes.ALLOCATE_PAYMENTS_2_IB_OPENING:
      return { ...state, ibOpening: action.payload };
    case actionTypes.UPDATE_PQAS_PREV_NEXT_QTR:
      return { ...state, qtrVal: action.payload };
    case actionTypes.SET_IS_CANCELING:
      return { ...state, isCanceling: action.payload };
    case actionTypes.CLEAR_NP_SUSPENDED:
      return {
        ...state,
        npSuspended: null,
      };
    default:
      return state;
  }
};

export default reducer;
